import { KeyValueModel } from "model/api";
import { EnumAmbientePagamento } from "model/enums/enum-ambiente-pagamento";


export const AmbientePagamentoMock: KeyValueModel[] = [
  new KeyValueModel(EnumAmbientePagamento.Sandbox, 'Sandbox'),
  new KeyValueModel(EnumAmbientePagamento.Homologacao, 'Homologação'),
  new KeyValueModel(EnumAmbientePagamento.Producao, 'Produção')
];
